// @ts-check

import React from "react";
import { Badge } from "@shopify/polaris";

import { capitalize } from "utils/index";

const STATUS_BADGE_TONE = {
  ACTIVE: "success",
  PAUSED: "attention",
  DELETED: "critical",
  ARCHIVED: undefined,
};

export const AdCampaignStatus = ({ status }) => {
  if (!status) {
    return null;
  }

  return (
    <Badge tone={STATUS_BADGE_TONE[status]}>
      {capitalize(status.toLowerCase())}
    </Badge>
  );
};
